module.exports = __webpack_public_path__ + "img/图层 42@2x.1a8a2471.png";